import DOMPurify from 'dompurify';
export const sanitizeMinimalHtml = (html) => {
    if (!html)
        return '';
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'u'],
        ALLOWED_ATTR: [],
    });
};
